import React from 'react';
import { number } from 'prop-types';

const McNotes = ({ mcCount }) => (
  <div>
    This patient has taken {mcCount} MCs last 30 days, please refer him/her to a physical clinic for
    review.
  </div>
);

McNotes.propTypes = {
  mcCount: number.isRequired,
};

export default McNotes;
